export const MANY_SUBJECTS = 4;
